import img1 from './img/1.jpg'
import img2 from './img/2.jpg'
import img3 from './img/3.jpg'
import img4 from './img/4.jpg'
import img5 from './img/5.jpg'
import img6 from './img/6.jpg'
import img7 from './img/7.jpg'
import img8 from './img/8.png'

export const VIDEOS = [
    {
        id: 1,
        title: "Video 1",
        chanelName: "Orlov Alexey",
        img: img1,
    },
    {
        id: 2,
        title: "Video 2",
        chanelName: "Orlov Alexey",
        img: img2,
    },
    {
        id: 3,
        title: "Video 3",
        chanelName: "Orlov Alexey",
        img: img3,
    },
    {
        id: 4,
        title: "Video 4",
        chanelName: "Orlov Alexey",
        img: img4,
    },
    {
        id: 5,
        title: "Video 5",
        chanelName: "Orlov Alexey",
        img: img5,
    },
    {
        id: 6,
        title: "Video 6",
        chanelName: "Orlov Alexey",
        img: img6,
    },
    {
        id: 7,
        title: "Video 7",
        chanelName: "Orlov Alexey",
        img: img7,
    },
    {
        id: 8,
        title: "Video 8",
        chanelName: "Orlov Alexey",
        img: img8,
    }
];